import React, { Component } from "react";
import {Grid, Row, Col, Table} from "react-bootstrap";
import PropTypes from 'prop-types';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import Card from "../../components/Card/Card.jsx";
import {avArray} from "../../variables/Variables";
import {connect} from "react-redux";
import CustomButton from "../../components/CustomButton/CustomButton";

import {addAvailabilitySlot, removeAvailabilitySlot, getAvailability} from "../../actions/scheduleActions";

class Availability extends Component {
    constructor(props) {
        super(props);
        this.state = {
            stateDate: new Date(),
            installType: "1"
        }

        this.state.stateDate.setHours(0);
        this.state.stateDate.setMinutes(0);
        this.state.stateDate.setSeconds(0);

        this.handleChange = this.handleChange.bind(this);
        this.handleInstallChange = this.handleInstallChange.bind(this);
        this.submitAvailability = this.submitAvailability.bind(this);
        this.deleteSlot = this.deleteSlot.bind(this);
    }

    componentDidMount() {
        const availabilityParams = {
            installer_id: this.props.auth.installer ? this.props.auth.installer.id : "",
            session: localStorage.getItem('sessionToken'),
            limit: 200,
            page: 1,
            sort_field: "appointment_date",
            type: "availability"
        }
        this.props.getAvailability(availabilityParams);
    }

    handleChange(date) {
        this.setState({
            stateDate: date
        });
    }

    handleInstallChange(type) {
        this.setState({
            installType:type.currentTarget.value
        });
    }

    submitAvailability(e) {
        e.preventDefault();
        const availability = {
            type: this.state.installType,
            date: this.state.stateDate,
            number: 1,
            session: localStorage.getItem('sessionToken'),
            installer_id: this.props.auth.installer ? this.props.auth.installer.id : "",
        }
        this.props.addAvailabilitySlot(availability);
    }

    deleteSlot(slotId, key) {
        console.log("delete slot" + slotId);
        const removal = {
            id: slotId,
            row: key,
            session: localStorage.getItem('sessionToken'),
        }
        this.props.removeAvailabilitySlot(removal);
    }

  render() {

        let availability;
        if  (this.props.schedule.availability.data !== undefined) {

            availability = this.props.schedule.availability.data.availability_slots.map((prop, key) => {
                return (
                    <tr key={key}>
                        {prop.wrap_appointment_type_id === "1" && <th>Install</th>}{prop.wrap_appointment_type_id === "2" && <th>Uninstall</th>}
                        <th>{prop.appointment_date}</th>
                        <th><CustomButton onClick={() => this.deleteSlot(prop.id, key)} fill={true}>Delete</CustomButton></th>
                    </tr>
                );
            })
        } else {
            availability = <tr></tr>;
        }

    return (
      <div className="content">
        <Grid fluid>
          <Row>
            <Col md={12}>

                <Card
                    title="Add New Availability Slot"
                    ctTableFullWidth
                    ctTableResponsive
                    content={
                        <Table striped hover>
                            <thead>
                            <tr>
                                <th>APPOINTMENT TYPE</th><th>APPOINTMENT DATE</th><th></th>
                            </tr>
                            </thead>
                            <tbody>
                                    <tr>
                                        <th>
                                            <select onChange={this.handleInstallChange} value={this.state.installType}>
                                              <option value="1">Install</option>
                                              <option value="2">Uninstall</option>
                                            </select>
                                        </th>
                                        <th><DatePicker
                                            selected={this.state.stateDate}
                                            onChange={this.handleChange}
                                            minDate={new Date()}
                                            />
                                        </th>
                                        <th><CustomButton onClick={this.submitAvailability} fill={true}>Submit</CustomButton></th>
                                    </tr>
                            </tbody>
                        </Table>
                    }
                />
              <Card
                  title="Installer Availability"
                  category="Jobs that need to be done"
                  ctTableFullWidth
                  ctTableResponsive
                  content={
                    <Table striped hover>
                      <thead>
                      <tr>
                          {avArray.map((prop, key) => {
                              return <th key={key}>{prop}</th>;
                          })}
                      </tr>
                      </thead>
                      <tbody>
                        {availability}
                      </tbody>
                    </Table>
                  }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

Availability.propTypes = {
    auth: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired,
    schedule: PropTypes.object.isRequired,
    completedSchedule: PropTypes.object.isRequired,
    addAvailabilitySlot: PropTypes.func.isRequired,
    removeAvailabilitySlot: PropTypes.func.isRequired,
    getAvailability: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
    auth: state.auth,
    errors: state.errors,
    schedule: state.schedule,
    completedSchedule: state.schedule
});

export default connect(mapStateToProps, {addAvailabilitySlot, removeAvailabilitySlot, getAvailability})(Availability);



// WEBPACK FOOTER //
// ./src/views/Availability/Availability.jsx